import React, { FC } from 'react';
import { ReactComponent as Reports } from '../../../assets/MainMenu/Reports.svg';

export const ReportsIcon: FC = () => <Reports />;
